<template>
  <Top5UsualCycling />
</template>

<script>
import Top5UsualCycling from '@/components/top5UsualCyclingCard.vue';

export default {
  components: {
    Top5UsualCycling,
  },
};
</script>

<style lang="scss" scoped></style>
